<template>
    <div class="docs-status-bar">
        <div class="container container-display">
            <div :style="uiConfigs.todo.style" class="bg-home-todo" v-if="uiConfigs.todo.percentage>0">
                <div><span>{{uiConfigs.todo.percentage}}%</span></div>
            </div>
            <div :style="uiConfigs.skipped.style" class="bg-home-skipped" v-if="uiConfigs.skipped.percentage>0">
                <div><span>{{uiConfigs.skipped.percentage}}%</span></div>
            </div>
            <div :style="uiConfigs.done.style" class="bg-home-done" v-if="uiConfigs.done.percentage>0">
                <div><span>{{uiConfigs.done.percentage}}%</span></div>
            </div>
        </div>
        <div class="container container-hover">
            <div :style="uiConfigs.todo.style" v-if="uiConfigs.todo.percentage>0">
                <div :data-tooltip="uiConfigs.todo.label" @mouseenter="onMouseEnterTooltipTarget"
                     @mouseleave="onMouseLeaveTooltipTarget" data-tooltip-pos="up"><span></span></div>
            </div>
            <div :style="uiConfigs.skipped.style" v-if="uiConfigs.skipped.percentage>0">
                <div :data-tooltip="uiConfigs.skipped.label" @mouseenter="onMouseEnterTooltipTarget"
                     @mouseleave="onMouseLeaveTooltipTarget" data-tooltip-pos="up"><span></span></div>
            </div>
            <div :style="uiConfigs.done.style" v-if="uiConfigs.done.percentage>0">
                <div :data-tooltip="uiConfigs.done.label" @mouseenter="onMouseEnterTooltipTarget"
                     @mouseleave="onMouseLeaveTooltipTarget" data-tooltip-pos="up"><span></span></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {numberWithCommas} from "@/utils";

    export default {
        name: "DocsStatusBar",
        props: {
            counts: {
                type: Object
            }
        },
        computed: {
            uiConfigs() {
                const {total, todo, done, skipped} = this.counts;
                const percentageTodo = todo/total*100;
                const percentageSkipped = skipped/total*100;
                const percentageDone = done/total*100;

                let todoWidth, todoPadding;
                let skippedWidth, skippedPadding;
                let doneWidth, donePadding;

                skippedWidth = `${percentageSkipped+percentageDone}%`;
                skippedPadding = `0 0 0 ${percentageDone}%`;

                todoWidth = '100%';
                todoPadding = `0 0 0 ${skippedWidth}`;

                doneWidth = `${percentageDone}%`;
                donePadding = '0';

                return {
                    todo: {
                        style: `width:${todoWidth};left:0;padding:${todoPadding};`,
                        percentage: Math.round(percentageTodo),
                        label: `Todo ${Math.round(percentageTodo)}% (${numberWithCommas(todo)}/${numberWithCommas(total)})`,
                    },
                    skipped: {
                        style: `width:${skippedWidth};left:0;padding:${skippedPadding};`,
                        percentage: Math.round(percentageSkipped),
                        label: `Skipped ${Math.round(percentageSkipped)}% (${numberWithCommas(skipped)}/${numberWithCommas(total)})`,
                    },
                    done: {
                        style: `width:${doneWidth};left:0;padding: ${donePadding};`,
                        percentage: Math.round(percentageDone),
                        label: `Done ${Math.round(percentageDone)}% (${numberWithCommas(done)}/${numberWithCommas(total)})`,
                    }
                }
            }
        },
        methods: {
            numberWithCommas: numberWithCommas,
        }
    }
</script>

<style scoped lang="scss">
    .docs-status-bar {
        position: relative;
        height: 1.8rem;
    }

    .container {
        height: 100%;
        width: 100%;
        position: absolute;
        border-radius: 1.8rem;

        &.container-display {
            overflow: hidden;
        }

        &.container-hover {
            [aria-label][data-balloon-pos] {
                cursor: default;
            }
        }

        & > div {
            height: 100%;
            position: absolute;
            text-align: center;
            border-radius: 0 1.8rem 1.8rem 0;

            div {
                height: 100%;
                font-size: 0.86em;

                span {
                    line-height: 1.8rem;
                    display: inline-block;
                    white-space: nowrap;
                    max-width: 100%;
                    overflow: hidden;
                    border-left: 0.1rem solid transparent;
                    border-right: 0.1rem solid transparent;
                    text-overflow: ellipsis;
                }
            }
        }
    }
</style>
